import React, { useState, useEffect } from "react";
import Humanize from "humanize-plus";

import { ReactComponent as ExpandIcon } from "src/asset/ic_expand_group.svg";
import { ReactComponent as CollapseIcon } from "src/asset/ic_collapse_group.svg";

import styles from "./styles.module.scss";

const GroupExpandRenderer = ({ value, data, node }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const hasDetail =
        data && (data.num_owners > 0 || data.outstanding_trades > 0);

    useEffect(() => {
        if (node) {
            setIsExpanded(node.expanded || false);
        }
    }, [node]);

    const handleExpandClick = (e) => {
        e.stopPropagation();

        if (!hasDetail) return;

        if (!isExpanded) {
            node.setExpanded(true);
            setIsExpanded(true);
        } else {
            node.setExpanded(false);
            setIsExpanded(false);
        }
    };

    return (
        <div className={styles.container}>
            <span className={styles.value}>{Humanize.intComma(value)}</span>
            <button
                className={styles.expandButton}
                onClick={handleExpandClick}
                type="button"
                title={isExpanded ? "Collapse detail" : "Expand to see detail"}
                disabled={!hasDetail}
            >
                {isExpanded ? (
                    <CollapseIcon className={styles.icon} />
                ) : (
                    <ExpandIcon className={styles.icon} />
                )}
            </button>
        </div>
    );
};

export default GroupExpandRenderer;
